<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">{{ $t('all-groups-prelim-votes') }}</div>
      <div :class="$groupsStyle.actionsContainer">
        <!-- <div title="View text details" :class="$style.infoContainer" @click="openInfoModal">
          <img :class="$style.infoIcon" :src="infoIcon" alt="info" />
        </div> -->
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsPrelimVotes">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <div v-for="(group, index) in props.groups" :key="index" :class="$style.groupPrelimVotesContainer">
        <PrelimVotesDisplayBox
          :preliminaryVotes="group.prelimVotes"
          :texts="texts"
          :user="user"
          :isHost="isHost"
          :title="getGroupDisplayName(group, index, t)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/AllGroupsPrelimVotesBox.module.css";
// import globalStyles from "@/css/global.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import PrelimVotesDisplayBox from "./PrelimVotesDisplayBox.vue";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const $style = styles;
// const $globalStyle = globalStyles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsPrelimVotes: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
  isHost: {
    type: Boolean,
    required: true,
  },
  texts: {
    type: Array,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped></style>
